
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^((27|51|94)1|320|455|562|626|670|812)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
